import { htmlId } from 'utils/html';

import { StyledContainer, Text } from './Badge.styles';
import { BadgeProps } from './Badge.types';

const Badge = (props: BadgeProps) => {
  const { children, variant } = props;
  return (
    <StyledContainer id={htmlId('badge')} background={variant}>
      {children}
    </StyledContainer>
  );
};

Badge.Text = Text;
export default Badge;
